import { CommonModule } from '@angular/common';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NAV_ITEMS } from "src/environments/environment";
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  navItems = NAV_ITEMS;
  constructor(private router: Router) {}
























  img = {
    color: "yellow",
    background: "url(../../assets/IMP PVP Tool Icons/library.svg)",
  };
  getImage() {
    return "../../assets/IMP PVP Tool Icons/library.svg";
  }
  backgroundUrl = "../../assets/IMP PVP Tool Icons/library.svg";
  ngOnInit(): void {}
  redirect(route) {
    this.router.navigate(["/" + route]);
  }
}
